import '../Popup.css'; // Import your CSS file for styling

import React, {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';
import { useParams } from 'react-router-dom';
import Select from 'react-select';

import {
  API_BASE_URL,
  API_KEY,
} from '../../constants';
import axiosInstance from '../../axios';
import offer from '../../assets/offer.jpg'
function InviteForm({ isOpen, onClose, onInvite, onCancel, onInputChange,accessToken,refreshToken,axiosAppInstance,passPaymentEventToApp,initiateDownload,selectLanguage,selectCurrency,flag,popupStep,setPopupStep,exportType,setExportType,hasExceededLimit}) {
  const { userId } = useParams();
  const [languages, setLanguage] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [loading, setLoading] = useState(true);
  const [LanguageList, setLanguageList] = useState(selectLanguage);
  useEffect(() => {
  setLanguageList(selectLanguage)
}, [selectLanguage]);

const [CurrencyList, setCurrencyList] = useState(selectCurrency);

useEffect(() => {
  setCurrencyList(selectCurrency);
}, [selectCurrency]);

  useEffect(() => {
    const fetchFontDetails = async () => {
      try {
        const response = await axiosAppInstance.get(`${API_BASE_URL}language-font-mapping/`);

        // Map the API response to an array of objects with value and label properties
        const languageOptions = response.data.data.map(font_family => ({
          value: font_family.font_family,
          label: font_family.language,
          id:font_family.id
        }));

        setLanguage(languageOptions);
      } catch (error) {
        console.error('Error fetching Languages:', error);
      } 
    };

    fetchFontDetails();
  }, []);

  useEffect(() => {
    const fetchCurrencyDetails = async () => {
      try {
        const response = await axiosAppInstance.get(`${API_BASE_URL}currencies/`);
        console.log(response)
        // Map the API response to value-label format for dropdown
        const currencyOptions = response.data.data.map(currency => ({
          value: currency.symbol,
          label: `${currency.symbol}-${currency.name}`,
          id: currency.id,
          code:currency.code
        }));
        console.log(currencyOptions)
        setCurrency(currencyOptions);
      } catch (error) {
        console.error('Error fetching Currencies:', error);
      }
    };
  
    fetchCurrencyDetails();
  }, []);
  
  const handleCountryCodeChange = (selectedOption) => {
    setLanguageList((prevLang) => ({
      ...prevLang,
      language: selectedOption,
    }));
  };

  const handleCurrencyChange = (selectedOption) => {
    setCurrencyList((prevLang) => ({
      ...prevLang,
      currency: selectedOption,
    }));
  };
  
  const [isFitTreeChecked, setIsFitTreeChecked] = useState(false);

const handleFitTreeChange = (e) => {
  setIsFitTreeChecked(e.target.checked);
  // Additional logic when the checkbox is toggled, if necessary
};
const handleExportTypeChange = (selectedOption) => {
  setExportType(selectedOption);
  console.log("Selected export type:", selectedOption.value);
  
};

// return isOpen ? (
//   <div className="popup-overlay">
//     <div className="popup" style={{ position: 'relative', padding: '20px', backgroundColor: '#fff', borderRadius: '8px' }}>
//       <>
//         {/* Close Button */}
//         <button onClick={onClose} style={{
//           position: 'absolute',
//           top: '10px',
//           padding: '5px',     // Reduced padding
//           width: '30px',      // Explicit button size
//           height: '30px',
//           lineHeight: '16px', // Align the text inside
//           right: '10px',
//           backgroundColor: 'transparent',
//           border: 'none',
//           fontSize: '30px',
//           cursor: 'pointer',
//           color: '#888',
//         }}>
//           &times;
//         </button>

//         <div className="button-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          
//           {flag ? (
//             <>
//               {/* Heading */}
//               <h2 style={{ textAlign: 'center' }}>Please provide instructions for download</h2>
              
//               {/* Language Dropdown */}
//               <div className="input-container" style={{ display: 'flex', alignItems: 'center' }}>
//                 <label htmlFor="countryCode" style={{ marginRight: '10px', width: '132px' }}>
//                   Language:
//                 </label>
//                 <Select
//                   id="language"
//                   value={LanguageList.language}
//                   onChange={handleCountryCodeChange}
//                   options={languages}
//                   placeholder="Select Language..."
//                   menuPlacement="top" 
//                 />
//               </div>

//               {/* Fit Tree to Page Checkbox */}
//               <div className="input-container" style={{ display: 'flex', alignItems: 'center' }}>
//                 <label htmlFor="fitTreeCheckbox" style={{ marginRight: '10px', fontSize: '16px',paddingTop:'7px' }}>Fit Tree to Page</label>
//                 <input
//                   type="checkbox"
//                   id="fitTreeCheckbox"
//                   checked={isFitTreeChecked} // Managed by a state variable
//                   onChange={handleFitTreeChange} // Handle checkbox toggle
//                   style={{
//                     transform: 'scale(1.2)',  // Scale the checkbox to match the size of the label text
//                     verticalAlign: 'middle'    // Ensures vertical alignment
//                   }}
//                 />
//               </div>

//               {/* Download Button */}
//               <button
//                 onClick={() => initiateDownload(true, LanguageList.language, isFitTreeChecked)} // Custom download function
//                 style={{
//                   backgroundColor: '#0a6783',
//                   color: '#fff',
//                   padding: '10px 20px',
//                   border: 'none',
//                   borderRadius: '4px',
//                   cursor: 'pointer',
//                   marginTop: '20px',
//                   textAlign: 'center',
//                 }}
//               >
//                 Download
//               </button>
//             </>
//           ) : (
//             <>
//             <div className="input-container" style={{ display: 'flex', alignItems: 'center' }}>
//                 <label htmlFor="currency" style={{ marginRight: '10px', width: '132px' }}>
//                   <b>Select Currency:</b>
//                 </label>
//                 <Select
//                   id="currency"
//                   value={CurrencyList.currency}
//                   onChange={handleCurrencyChange}
//                   options={currency}
//                   menuPlacement="top" 
//                 />
//               </div>

//               <button onClick={() => passPaymentEventToApp(CurrencyList.currency)}>
//                   Buy Now
//                 </button>
//               {/* </div> */}

//               {/* Download with Watermark Button */}
//               <a href="#" onClick={(e) => { e.preventDefault(); initiateDownload(false, LanguageList.language, isFitTreeChecked); }}>
//                 Continue With Free Download
//               </a>

//               {/* Language Dropdown */}
//               <div className="input-container" style={{ display: 'flex', alignItems: 'center' }}>
//                 <label htmlFor="countryCode" style={{ marginRight: '10px', width: '132px' }}>
//                  <b> Tree Language:</b>
//                 </label>
//                 <Select
//                   id="language"
//                   value={LanguageList.language}
//                   onChange={handleCountryCodeChange}
//                   options={languages}
//                   placeholder="Select Language..."
//                   menuPlacement="top" 
//                 />
//               </div>

//               {/* Checkbox for "Fit Tree to Page" */}
//               <div className="input-container" style={{ display: 'flex', alignItems: 'center' }}>
//                 <label htmlFor="fitTreeCheckbox" style={{ marginRight: '10px', fontSize: '16px',paddingTop:'7px' }}><b>Fit Tree to Page</b></label>
//                 <input
//                   type="checkbox"
//                   id="fitTreeCheckbox"
//                   checked={isFitTreeChecked} // Managed by a state variable
//                   onChange={handleFitTreeChange} // Handle checkbox toggle
//                   style={{
//                     transform: 'scale(1.2)',  // Scale the checkbox to match the size of the label text
//                     verticalAlign: 'middle'    // Ensures vertical alignment
//                   }}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//       </>
//     </div>
//   </div>
// ) : null
return isOpen ? (
  <div className="popup-overlay">
    <div className="popup" style={{ position: 'relative', padding: '20px', backgroundColor: '#fff', borderRadius: '8px' }}>
      {/* Close Button */}
      <div style={{ display: 'flex', width: '100%' }}>
          <button
            onClick={onClose}
            style={{
              marginLeft: 'auto',
              backgroundColor: 'transparent',
              border: 'none',
              fontSize: '30px',
              cursor: 'pointer',
              color: '#888',
              width: '30px',
              height: '30px',
              lineHeight: '30px',
              padding: 0,
            }}
          >
            &times;
          </button>
        </div>



      {/* Back Button (if not on initial step) */}
      {!hasExceededLimit && popupStep !== 'initial' && popupStep !== 'free' && (
        <button
        onClick={() => setPopupStep('initial')}
        style={{
          position: 'absolute',
          top: '20px',
          left: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          width: '30px',
          height: '30px',
          fontSize: '30px',
          color: '#888',
          zIndex: 1000, // Optional: ensures it stays on top
        }}
      >
        &larr;
      </button>
      
      
      )}

      <div className="button-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {popupStep === 'initial' && (
          <>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <img src={offer} alt="Your description" style={{
                                      width: '100%', // Adjust width as needed
                                      maxWidth: '260px', // Set a max width for the image
                                      height: 'auto', // Maintain aspect ratio
                                      marginBottom: '10px' // Space between image and button
                        }} />
            <button onClick={() => setPopupStep('buy')}>Buy Now</button>
            </div>
           <a
            href="#"
            className="custom-link"
            onClick={(e) => {
              e.preventDefault();
              setPopupStep('free');
            }}
          >
            Continue With Free Download
          </a>

          </>
        )}

 {popupStep === 'buy' && (
  <>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '14px', // vertical spacing between rows
        width: '320px',
        margin: '0 auto',
      }}
    >
      {/* Currency */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label
          htmlFor="currency"
          style={{
            fontWeight: 'bold',
            width: '130px',
            textAlign: 'right',
            marginRight: '10px',
          }}
        >
          Select Currency:
        </label>
        <div style={{ width: '180px' }}>
          <Select
            id="currency"
            value={CurrencyList.currency}
            onChange={handleCurrencyChange}
            options={currency}
            menuPlacement="top"
            isSearchable={false}
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: '32px',
                fontSize: '12px',
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: 'left',
                fontSize: '12px',
              }),
              option: (provided) => ({
                ...provided,
                textAlign: 'left',
                fontSize: '12px',
                padding: '6px 10px',
              }),
            }}
          />
        </div>
      </div>

      {/* Language */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label
          htmlFor="language"
          style={{
            fontWeight: 'bold',
            width: '130px',
            textAlign: 'right',
            marginRight: '10px',
          }}
        >
          Language:
        </label>
        <div style={{ width: '180px' }}>
          <Select
            id="language"
            value={LanguageList.language}
            onChange={handleCountryCodeChange}
            options={languages}
            menuPlacement="top"
            isSearchable={false}
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: '32px',
                fontSize: '12px',
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: 'left',
                fontSize: '12px',
              }),
              option: (provided) => ({
                ...provided,
                textAlign: 'left',
                fontSize: '12px',
                padding: '6px 10px',
              }),
            }}
          />
        </div>
      </div>

      {/* Fit Tree */}
   <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <label
    htmlFor="fitTreeCheckbox"
    style={{
      fontWeight: 'bold',
      width: '130px',
      textAlign: 'right',
      whiteSpace: 'nowrap',
    }}
  >
    Fit Tree to Page:
  </label>

  {/* Checkbox right next to label */}
  <input
    type="checkbox"
    id="fitTreeCheckbox"
    checked={isFitTreeChecked}
    onChange={handleFitTreeChange}
    style={{ transform: 'scale(1.2)' }}
  />
</div>


      {/* Export Type */}
 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '8px',
      whiteSpace: 'nowrap',
      marginLeft: '-10px', // slight left shift for label only
    }}
  >
    <label
      htmlFor="exportType"
      style={{
        fontWeight: 'bold',
        textAlign: 'right',
        minWidth: '120px', // matches typical label width above
        marginRight: '8px',
      }}
    >
      Download Format:
    </label>

    <div style={{ width: '180px' }}>
      <Select
        id="exportType"
        value={exportType}
        onChange={handleExportTypeChange}
        options={[
          { value: 'pdf', label: 'PDF' },
          { value: 'png', label: 'PNG' },
          { value: 'html', label: 'HTML' },
        ]}
        isSearchable={false}
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: '32px',
            fontSize: '12px',
          }),
          singleValue: (provided) => ({
            ...provided,
            textAlign: 'left',
            fontSize: '12px',
          }),
          option: (provided, state) => ({
            ...provided,
            fontSize: '12px',
            padding: '6px 10px',
            textAlign: 'left',
          }),
        }}
      />
    </div>
  </div>

        {/* Instruction note */}
        <p
          style={{
            fontSize: '11px',
            color: '#666',
            fontStyle: 'italic',
            margin: '2px 0 0 142px'
          }}
        >
          For non english, please select <strong>PNG</strong> or <strong>html</strong>.
        </p>
      </div>
    </div>

    {/* Buy Now Button */}
    <button
      style={{
        marginTop: '20px',
        padding: '8px 16px',
        fontSize: '14px',
        fontWeight: 'bold',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
      onClick={() => passPaymentEventToApp(CurrencyList.currency)}
    >
      Buy Now
    </button>
  </>
)}


        {popupStep === 'free' && (
          <>
          <div style={{ position: 'relative', height: '122px',top:"-60px" }}>
          <label
    htmlFor="language"
    style={{
      position: 'absolute',
      top: '50px',
      right: '15px',
      width: '150px',  // Ensure this width prevents wrapping
      fontWeight: 'bold',
    }}
  >
    Language:
  </label>

  {/* Language Dropdown */}
  <div style={{ position: 'absolute', top: '50px', width: '200px',left:"-30px" }}>
    <Select
      id="language"
      value={LanguageList.language}
      onChange={handleCountryCodeChange}
      options={languages}
      menuPlacement="top"
      isSearchable={false}
       styles={{
      singleValue: (provided) => ({
        ...provided,
        textAlign: 'left',  // Left-align the selected value
      }),
      option: (provided) => ({
        ...provided,
        textAlign: 'left',  // Left-align the options in the dropdown
      }),
      menuList: (provided) => ({
        ...provided,
        padding: '0',  // Optional: removes extra padding from the menu list
      }),
    }}
    />
  </div>

  {/* Label: Fit Tree */}
  <label
    htmlFor="fitTreeCheckbox"
    style={{
      position: 'absolute',
      top: '110px',
      right: '36px',
      width: '150px',  // Ensure this width prevents wrapping
      whiteSpace: 'nowrap',  // Prevent label text from breaking into two lines
      fontWeight: 'bold',
    }}
  >
    Fit Tree to Page:
  </label>

  {/* Checkbox */}
  <input
    type="checkbox"
    id="fitTreeCheckbox"
    checked={isFitTreeChecked}
    onChange={handleFitTreeChange}
    style={{
      position: 'absolute',
      top: '115px',
      transform: 'scale(1.2)',
      right:"15px"
    }}
  />
    <label
    htmlFor="exportType"
    style={{
      position: 'absolute',
      top: '160px', // adjust as needed
      right: '44px',
      width: '150px',
      fontWeight: 'bold',
    }}
  >
    Download Format:
  </label>

  {/* Export Type Dropdown */}
 <div style={{ position: 'absolute', top: '160px', width: '200px', left: '-30px' }}>
  <Select
    id="exportType"
    value={exportType}
    onChange={handleExportTypeChange}
    options={[
      { value: 'pdf', label: 'PDF' },
      { value: 'png', label: 'PNG' },
      { value: 'html', label: 'HTML' },
    ]}
    isSearchable={false}
    styles={{
      control: (provided) => ({
        ...provided,
        minHeight: '10px',     // shorter input height
        fontSize: '12px',      // smaller text inside the select box
      }),
      singleValue: (provided) => ({
        ...provided,
        fontSize: '12px',      // selected value font size
        textAlign: 'left'
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: '12px',      // dropdown options font size
        padding: '6px 10px',   // tighter spacing
        textAlign: 'left'
      }),
      menu: (provided) => ({
        ...provided,
        fontSize: '12px',      // menu text size
      }),
    }}
  />
   <p style={{
    fontSize: '11px',
    color: '#666',
    marginTop: '4px',
    textAlign: 'left',
    fontStyle: 'italic'
  }}>
    For non english, please select <strong>PNG</strong> or <strong>HTML</strong>.
  </p>
</div>

        </div>
            <button style={{marginTop: '50px'}} onClick={() => initiateDownload(flag, LanguageList.language, isFitTreeChecked)}>Download</button>
          </>
          
        )}
      </div>
    </div>
  </div>
) : null;

}

export default InviteForm;
